import { ApiClient } from '@webapp/core/services/ApiClient'
import { CatalogAccessRepository } from './CatalogAccessRepository'

export const catalogAccessRepository = new CatalogAccessRepository({
  httpClient: ApiClient,
})

export { CatalogAccessRepository }
